
<div class="col-lg-12" style="box-shadow: 0 0.46875rem 2.1875rem rgba(90, 97, 105, 0.1), 0 0.9375rem 1.40625rem rgba(90, 97, 105, 0.1), 0 0.25rem 0.53125rem rgba(90, 97, 105, 0.12), 0 0.125rem 0.1875rem rgba(90, 97, 105, 0.1);border-radius: 10px;padding: 0px;">
  <!-- !----card strat!---! -->
  <div class="main-card mb-3 card">
    <div class="card-body">
      <!-- !---!card body start---! -->
      <div class="mains" style="align-items: center;justify-content: space-between;">
        <nav aria-label="breadcrumb">
          <ol class="breadcrumb">
            <li class="breadcrumb-item"><a href="#" style="color:#0071bc"><i class="bi bi-house-add-fill mx-1" style="color:#0071bc" ></i>Home</a></li>
            <li class="breadcrumb-item active" style="color:darkgrey">User Account Management</li>
          </ol>
        </nav>
    
      <div class="sub" >
        <button class="btn  text-center text-white mx-3" (click)="openLarge(content1)" style="background-color:green;"><span class=" text-white"><i class="bi bi-plus"  id="s"></i></span>Add</button>
        <button class="btn  text-center text-white mx-3" (click)="openLarge(content1)" style="background-color:deeppink ;"><span><i class="bi bi-pen-fill mx-1" id="s"></i></span>Edit</button>
        <button class="btn  text-center text-white mx-3"(click)="openSmall(content7)" style="background-color:dodgerblue;"><span><i class="bi bi-search mx-1" id="s"></i></span>Search</button>
        <button class="btn  text-center text-white mx-3" (click)="Delete()" style="background-color: red;"><span><i class="bi bi-x "  id="s"></i></span>Delete</button>
        <!-- <button class="btn  text-center text-white mx-3" data-toggle="modal" data-target="#staticBackdrop" style="background-color:green ;" ><span class=" text-white"><i class="bi bi-plus"  id="s"></i></span>Sample</button> -->
        <!-- <button class="btn" data-toggle="modal" data-target="#exampleModal">add1</button> -->
      </div>
      <button class="btn bg-primary" style="border-radius:5px;display:none;" id="show" (click)="display()" > <i class="bi bi-three-dots-vertical text-white "></i></button> 
     </div> 
     <!-- !-----!----! -->
      <div class="mobile-only">
     <div class="container" style="padding:20px;background-color:azure; display:flex;justify-content: space-between;"   *ngIf="visible" >
       <button class="btn  text-center text-white "  (click)="openLarge(content1)" id="c" style="background-color:limegreen"><span class=" text-white"><i class="bi bi-plus" id="selected" ></i></span></button>
      <button class="btn  text-center text-white "  (click)="openLarge(content1)" id="c" style="background-color:deeppink"><span><i class="bi bi-pen " id="selected"></i></span></button>
       <button class="btn  text-center text-white "  (click)="openSmall(content7)" id="c" style="background-color: dodgerblue;"><span><i class="bi bi-search  "id="selected"></i></span></button>
       <button class="btn  text-center text-white "  (click)="Delete()" id="c" style="background-color: red;"><span><i class="bi bi-x"id="selected"></i></span></button>
     </div> 
     </div> 
      <!-- !-----! -->
      <div class="table-responsive">
        <!-- !----!---! -->
      <table class="mb-0 table table-striped">
        <thead style="background-color:#0071bc">
          <tr >
            <th id="common" class="border border-white text-center">
              <div style="vertical-align: middle;">
                <input type="checkbox"  [(ngModel)]="selectall" (change)="child()">
              </div>
            </th>
            <th scope="col" class="text-white border border-white" id="common">Unique ID</th>
            <th scope="col" class="text-white border border-white" id="common">Enable</th>
            <th scope="col" class="text-white border border-white" id="common">User ID</th>
            <th scope="col" class="text-white border border-white" id="common">Name</th>
            <th scope="col" class="text-white border border-white" id="common">User Plan</th>
            <th scope="col" class="text-white border border-white" id="common">Extended Usage Plan</th>
            <th scope="col" class="text-white border border-white" id="common">Account Validity</th>
            <th scope="col" class="text-white border border-white" id="common">Login Control</th>
            <th scope="col" class="text-white border border-white" id="common">Login Method</th>
            <th scope="col" class="text-white border border-white" id="common">Mac Binding</th>
            <th scope="col" class="text-white border border-white" id="common">Bandwidth Priority</th>
            <th scope="col" class="text-white border border-white" id="common">User ID</th>
            <th scope="col" class="text-white border border-white" id="common">First Name</th>
            <th scope="col" class="text-white border border-white" id="common">Last Name</th>
            <th scope="col" class="text-white border border-white" id="common">Account Reference</th>
            <th scope="col" class="text-white border border-white" id="common">Circuit ID</th>
            <th scope="col" class="text-white border border-white" id="common">Mobile Number</th>
            <th scope="col" class="text-white border border-white" id="common">Email Address</th>
            <th scope="col" class="text-white border border-white" id="common">Create Date</th>
            <th scope="col" class="text-white border border-white" id="common">Site ID</th>
            <th scope="col" class="text-white border border-white" id="common">Actions</th>
          </tr>
         </thead>
        <tbody>
        
          <tr *ngFor="let item of value">
            <td class="text-center">
              <div style="vertical-align: middle;display: flex;padding: 10px 22px;" >
                <input type="checkbox" [(ngModel)]="item.selected" (change)="update(item)" >
              </div>
            </td>
             <td class="text-center">
               {{item.userid}}
            </td>   
              <td class="text-center">
              {{item.Enable}}
           </td>
           <td class="text-center">
            {{item.name}}
         </td>
         <td class="text-center">
          {{item.userplan}}
       </td>  
        
        </tbody>
      </table>
      <!-- !----!---! -->
      </div>
      <!-- !----!card body end---! -->
   </div>
    <!-- !----!pagination start----! -->
    <div class="mt-3 mx-3">
      <nav aria-label="Page navigation example">
        <ul class="pagination">
          <li class="page-item">
            <a class="page-link" href="#" aria-label="Previous">
              <span aria-hidden="true">&laquo;</span>
            </a>
          </li>
          <li class="page-item"><a class="page-link" href="#">1</a></li>
          <li class="page-item"><a class="page-link" href="#">2</a></li>
          <li class="page-item"><a class="page-link" href="#">3</a></li>
          <li class="page-item">
            <a class="page-link" href="#" aria-label="Next">
              <span aria-hidden="true">&raquo;</span>
            </a>
          </li>
        </ul>
      </nav>
     </div>
   <!-- !----! main card end---! -->
    </div>
   <!-- !----!pagination end ----! -->
  
  
  
  </div>
   <!-- !----!card  end-----! -->
<!-- !----!pop up modal----! -->

<div class="card main-card " style="display: none;">
  <div class="card-body">
    <ng-template #content1 let-c="close" let-d="dismiss">
      <div class="modal-header" style="background-color: ghostwhite;" >
        <div class="container ">
          <h3 style="background-color:orangered;color: white;font-weight: bold;padding:7px 50px; " class="text-center">Enter Customer Details</h3> 
        </div>
        <button type="button" class="btn-close " (click)="c('Cross click')" style="border: none;">
        </button>
      </div>
      <div class="modal-body pb-5 " style="background-color:ghostwhite;padding-left:25px;" >
        <div class="col-lg-12 row  " style="padding:20px 20px;justify-content: center;">
         <div class="col-lg-6">
          <label class="col-lg-6 fw-bold" id="label">FirstName</label>
            <div class="col-lg-12 mt-2 ">
              <input type="text" class="form-control" formControlName="firstname">
            </div>
         </div>
         <!-- !----!---! -->

         <div class="col-lg-6  ">
          <label class="col-lg-6"id="label">LastName</label>
            <div class="col-lg-12 mt-2">
              <input type="text" class="form-control" formControlName="firstname">
            </div>
         </div>
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6"id="label">Email Id</label>
            <div class="col-lg-12 mt-2" >
              <input type="email" class="form-control" formControlName="email">
            </div>
         </div>
         <!-- !-----!---! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Address</label>
            <div class="col-lg-12 mt-2">
              <input type="text" class="form-control" formControlName="address">
            </div>
         </div>
         <!-- !---!---! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Mobile Number</label>
            <div class="col-lg-12 mt-2">
              <input type="number" class="form-control" formControlName="mobile">
            </div>
         </div>
         <!-- !----!-----! -->
         <div class="col-lg-6 mt-2 ">
          <label class="col-lg-6" id="label">Date</label>
            <div class="col-lg-12 mt-2">
              <input type="date" class="form-control" formControlName="date">
            </div>
         </div>
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2 ">
          <label class="col-lg-6" id="label">User ID</label>
            <div class="col-lg-12 mt-2">
              <input type="number" class="form-control" formControlName="User_id">
            </div>
         </div>
         <!-- !----!----! -->
         <div class="col-lg-6 mt-2 ">
          <label class="col-lg-6" id="label">Unique ID</label>
            <div class="col-lg-12 mt-2">
              <input type="number" class="form-control" formControlName="Unique_id">
            </div>
         </div>
         <!-- !----!----! -->
         <div class="col-lg-6 mt-2 ">
          <label class="col-lg-6" id="label">Enable</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="Enable">
            </div>
         </div>
          
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2 ">
          <label class="col-lg-6" id="label">Extended Usage Plan</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="extent_plan">
            </div>
         </div>
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2 ">
          <label class="col-lg-6" id="label">Login Controls</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="login_controls">
            </div>
         </div>
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2 ">
          <label class="col-lg-6" id="label">Login Methods</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="login_methods">
            </div>
         </div>

         <!-- !----!----! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Circuit ID</label>
            <div class="col-lg-12 mt-2">
              <input type="number" class="form-control" formControlName="circuit_id">
            </div>
         </div>
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Site ID</label>
            <div class="col-lg-12 mt-2">
              <input type="number" class="form-control" formControlName="site_id">
            </div>
         </div>
         <!-- !----!--! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">User Plan</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="user_plan">
            </div>
         </div>
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Account Reference</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="acc_references">
            </div>
         </div>
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Account Validity</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="Validity">
            </div>
         </div>
         <!-- !----!--!--! -->

          <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Bandwidth Priority</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="Bandwidth">
            </div>
         </div>
         <!-- !----!--! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Test</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="test">
            </div>
         </div>
         <!-- !----!---! -->
         <div class="col-lg-6 mt-2">
          <label class="col-lg-6" id="label">Mac Binding</label>
            <div class="col-lg-12 mt-2">
              <input type="type" class="form-control" formControlName="mac_binding">
            </div>
         </div>
         <!-- !----!---! -->
        </div>
      </div>
      <div class="modal-footer" style="background-color: ghostwhite;" >
        <button type="button" class="btn text-center text-white fw-bold px-4" style="background-color:orangered">Save</button>
        <button type="button" class="btn text-center text-white fw-bold px-4" style="background-color:orangered"(click)="c('Close click')">Close</button>
       
      </div>
    </ng-template>
  </div>
</div>
<!-- !----!search----! -->
<div class="card main-card mb-3 bg-info " style="display: none;">
  <div class="card-body" style="background-color: ghostwhite;">
    <ng-template #content7 let-c="close" let-d="dismiss">
      <div class="modal-header">
        <div class="container text-center">
          <h4 class="modal-title" style="background-color:orangered;color: white;font-weight: bold;padding:7px;">Search Customer Details</h4>
        </div>
       
        <button type="button" class="btn-close" aria-label="Close" (click)="d('Cross click')">
        </button>
      </div>
      <div class="modal-body" style="background-color: ghostwhite;padding:40px;">
        <div class="col-lg-12  row" style="padding:20px 15px;">
         <label class="col-form-label col-lg-3" id="label">Search</label>
         <div class="col-lg-8">
          <input type="text" class="form-control" formControlName="serach_id">
         </div>
        </div>
      </div>
      <div class="modal-footer" style="background-color: ghostwhite;;">
        <button type="button" class="btn text-center text-white fw-bold px-4" style="background-color:orangered">Save </button>
        <button type="button" class="btn text-center text-white fw-bold px-4" (click)="c('Close click')" style="background-color:orangered">Close</button>
    
      </div>
    </ng-template>

  </div>
</div>
 <!-- !----model---! -->


<!-- !----!----! -->

<div class="modal fade" id="staticBackdrop" data-backdrop="static" data-keyboard="false" tabindex="-1" aria-labelledby="staticBackdropLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="staticBackdropLabel">WELCOME TO JEEVS WORLD</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        ...
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Understood</button>
      </div>
    </div>
  </div>
</div>




